<script>
  import Card from '../../../../components/containers/card';
  import Avatar from '../../../../components/containers/avatar';
  import moment from 'moment';

  export let value;

  const ICONS = {
    Registration: '/static/icons/calendar-check-1.1.png',
    Waitlist: '/static/icons/watch-time.png'
  };
</script>

<style>
  .time-bubble {
    display: flex;
    align-items: center;
    justify-content: center;
    height: calc(100% - 16px);
  }

  .time-bubble img {
    width: 26px;
    height: 26px;
  }

  .icon {
    background: #fbfbfb;
    padding: 16px;
    border-radius: 50%;
    box-shadow: 0 2px 2px 0 rgba(23, 28, 33, 0.06);
    width: 56px;
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>

<div class="grid-x grid-margin-x">
  {#each value.activity as activity}
  {#if activity.event}
    <div class="cell small-12 medium-1">
      <div class="time-bubble">
        <div class="icon">
          <img alt="time" src="{ICONS[activity.type]}" />
        </div>
      </div>
    </div>
    <div class="cell small-12 medium-11">
      <Card>
        <div class="u--padall">
          <h4>{activity.type}</h4>
          <h3>{activity.event.name} - {moment(activity.event.date).format('dddd MMMM Do')}</h3>
          <h5>On {moment(parseInt(activity.date)).format('dddd MMMM Do, YYYY hh:mm A')}</h5>
        </div>
      </Card>
    </div>
  {/if}
  {/each} {#if value.activity.length === 0}
  <div class="cell small-12 medium-12">
    <div class="callout">
      {value.firstName} {value.lastName} has no recent activity
    </div>
  </div>
  {/if}
</div>
